import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import arrow from "assets/home/joinFamily/arrow.svg";
import ApplicationProcess from "molecules/applicationPopup";

type JoinFamilyData = {
  _id: string;
  heading: string;
  description: string;
  desktopImage: string;
  mobileImage: string;
};

const linkData = [
  { title: "Donate", link: "/donate-us" },
  { title: "Become a Buddha Fellow", link: "" }, // handled separately
  { title: "Become a Mentor", link: "/contact-us" },
  { title: "Join our team", link: "/contact-us" },
];

const JoinFamily: React.FC = React.memo(() => {
  const [joinData, setJoinData] = useState<JoinFamilyData | null>(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_LOCAL_URL}/api/joinFamily/alldetails`
      );
      if (res.data.status === "success" && res.data.message.length) {
        setJoinData(res.data.message[0]);
      }
    } catch (error) {
      console.error("Error fetching Join Family data:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const getImageUrl = (image?: string) =>
    image
      ? `${process.env.REACT_APP_LOCAL_URL}/${image.replace(/\\/g, "/")}`
      : "";

  if (loading) return null;

  return (
    <section className="blade-top-padding-lg blade-bottom-padding-lg bg-[#1A8482]">
      <section className="w-container gsap-fade-in">
        <div className="md:flex items-end justify-between border-b border-[#FFFFFF]">
          <h1 className="pb-3 font-lato-bold text-[#FFFFFF]">
            {joinData?.heading || "Join the family"}
          </h1>
        </div>

        {joinData?.description && (
          <div className="text-white xl:mt-9 mt-4 lg:w-full">
            <h5
              className="font-lato-regular"
              dangerouslySetInnerHTML={{ __html: joinData.description }}
            />
          </div>
        )}

        {/* Desktop & Mobile Images */}
        {joinData?.desktopImage && (
          <div className="blade-top-margin-sm lg:block hidden">
            <img src={getImageUrl(joinData.desktopImage)} alt="Team of Buddha Institute" />
          </div>
        )}
        {joinData?.mobileImage && (
          <div className="blade-top-margin-sm lg:hidden block">
            <img src={getImageUrl(joinData.mobileImage)} alt="Team of Buddha Institute Mobile" />
          </div>
        )}

        {/* Grid Links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 blade-top-margin-sm">
          {linkData.map((item, index) =>
            item.title === "Become a Buddha Fellow" ? (
              <div
                key={index}
                onClick={() => setShowPopup(true)}
                className="cursor-pointer h-[120px] hover:bg-[#D6DF20] bg-white transition-all duration-500 flex items-center justify-between font-lato-regular px-5"
              >
                <h4 className="!font-medium">{item.title}</h4>
                <img src={arrow} alt="Arrow" />
              </div>
            ) : (
              <Link
                key={index}
                to={item.link}
                target="_blank"
                className="h-[120px] hover:bg-[#D6DF20] bg-white transition-all duration-500 flex items-center justify-between font-lato-regular px-5"
              >
                <h4 className="!font-medium">{item.title}</h4>
                <img src={arrow} alt="Arrow" />
              </Link>
            )
          )}
        </div>

        {showPopup && <ApplicationProcess onclose={() => setShowPopup(false)} />}
      </section>
    </section>
  );
});

export default JoinFamily;
